module.exports = __webpack_public_path__ + "img/sand.5f82b485.png";